<ion-row class="p-0 headerBreadcrumb"> </ion-row>
<div class="modal-body">
  <div class="phi-flex-wrap-center phi-gap-12 pt-10 pb-10">
    <!-- <div class="formLabelRegularfs16 mb-5">Year</div> -->
    <mat-form-field class="w-100 mw-sm-200  mat-height40 mat-input-style">
      <mat-select placeholder="Select" [(ngModel)]="selectedYear" (ngModelChange)="onYearChange($event)">
        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
          {{ sharedService.transformYearToFyFormat(item.year) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-multiselect-dropdown
      class="w-100 mw-sm-200 mat-height40 fs-10"

      [placeholder]="'Select Department'"
      [settings]="dropdownSettings"
      [data]="getDepartmentsList"
      [(ngModel)]="selectedDepartment"
      (onSelect)="onSelectDepartment()"
      (onDeSelect)="onDeSelectDepartment()"
      (onSelectAll)="selectAllDepartment($event)"
      (onDeSelectAll)="onDeSelectAllDepartment()"
    >
    </ng-multiselect-dropdown>

    <ng-multiselect-dropdown
      class="w-100 mw-sm-200 mat-height40"
      [placeholder]="'Select Employee'"
      [settings]="dropdownSettings"
      [data]=" getEmployeeList"
      [(ngModel)]="selectedEmployeeForFilter"
      (onSelect)="onSelectdEmp()"
      (onDeSelect)="onDeSelectdEmployee()"
      (onSelectAll)="selectAllEmployee($event)"
      (onDeSelectAll)="onDeSelectAllEmployee()"
    >
    </ng-multiselect-dropdown>
  </div>


  <ion-row>
    <ion-col size>
        <mat-form-field class="mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchAppoinmentTableData" (input)="appoinmentReportSearch()"/>
        </mat-form-field>
    </ion-col>

    <ion-col size="auto">
      <div class="phi-flex-wrap-center phi-gap-12">
	      <label class="phi-flex phi-gap-6 phi-align-items-center">
        <ion-label class="center-content fs-14 fs_12ForMobile font_medium black_color">Show</ion-label>
        <mat-form-field class="w70px mat-height40 mat-input-style">
          <mat-select [value]="25">
            <mat-option [value]="25">25</mat-option>
            <mat-option [value]="50">50</mat-option>
            <mat-option [value]="75">75</mat-option>
            <mat-option [value]="100">100</mat-option>
          </mat-select>
        </mat-form-field>
        <ion-label class="center-content fs-14 fs_12ForMobile font_medium black_color">entries</ion-label>
        </label>
      </div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="horizontal-row"></div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="selectDownload">
        <div class="select-comgination-checkbox">
          <section class="mat-checkbox-style">
            <mat-checkbox
              [(ngModel)]="selectAllChecked"
              (change)="toggleSelectAll()"
              >Select All</mat-checkbox
            >
          </section>
        </div>
        <div *ngIf="isShowDownloadBtn">
          <button
            class="materialBtnIcon black_color fs-14 fs_12ForMobile font_semibold mr-15"
            (click)="downloadSelected()"
          >
            <span class="material-icons">download</span>
          </button>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col
      size-sm="12"
      size-md="12"
      size-lg="12"
      size-xs="12"
      class="d-flex"
      style="gap: 16px"
    >
      <div class="card-container">

        <div
          class="cardBox"
          *ngFor="let data of appoinmentLetterDataforTable; let id = index"
        >
          <div>
            <section class="mat-checkbox-style fs-12">
              <mat-checkbox
                [(ngModel)]="data.isChecked"
                (change)="onCheckboxChange($event, data)"
                >{{ data.firstName }} {{data.lastName}}</mat-checkbox
              >
            </section>
          </div>
          <div class="cartContent">
            <span class="material-icons fs-12 text_blue">visibility</span
            ><span
              class="fs-12 text_blue cp"
              (click)="onClickPreviewLetter(data.firstName , data.candidateId,data.appointmentLetterFileName)"
            >
              Preview</span
            >
           
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
</div>
